export default __webpack_public_path__ + "static/media/thumbnail1.a074b836.gif";